import { create } from 'zustand';
const usePurchaseState = create(() => ({
    productsOfPlatform: 'uninitialized',
    productsOfActiveBroadcast: [],
}));
const reactiveOutput = {
    useProductsOfPlatform() {
        return usePurchaseState((state) => state.productsOfPlatform);
    },
    useProductsOfActiveBroadcast() {
        return usePurchaseState((state) => state.productsOfActiveBroadcast);
    },
};
export class PurchaseServiceOutput {
    static instance;
    constructor() { }
    static getInstance() {
        if (!PurchaseServiceOutput.instance) {
            PurchaseServiceOutput.instance = new PurchaseServiceOutput();
        }
        return PurchaseServiceOutput.instance;
    }
    static getReactiveOutput() {
        return reactiveOutput;
    }
    setProductsOfPlatform(value) {
        usePurchaseState.setState({ productsOfPlatform: value });
    }
    setProductsOfActiveBroadcast(value) {
        usePurchaseState.setState({ productsOfActiveBroadcast: value });
    }
}
